export type Theme = "light" | "dark";

export const getStoredTheme = (): Theme => {
  const stored = localStorage.getItem("theme");
  if (stored === "dark" || stored === "light") {
    return stored;
  }
  // Default to light theme
  return "light";
};

export const setStoredTheme = (theme: Theme): void => {
  localStorage.setItem("theme", theme);
};

export const applyTheme = (theme: Theme): void => {
  const root = document.documentElement;

  if (theme === "dark") {
    root.classList.add("dark-theme");
    root.classList.remove("light-theme");
  } else {
    root.classList.add("light-theme");
    root.classList.remove("dark-theme");
  }

  setStoredTheme(theme);
};
